import React, {
  useEffect,
  useRef,
  useState,
} from 'react';
import { observer } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import { useStores } from '../../hooks/use-stores';
import {
  Form,
  Formik,
} from 'formik';
import {
  Button,
  Checkbox,
  Col,
  ControlLabel,
  FormGroup,
  Row,
} from 'react-bootstrap';
import LoadingButton from '../../components/LoadingButton/LoadingButton';
import startCase from 'lodash/startCase';

const SettingsNotifications = observer((props) => {
  const { t } = props;
  const { settingsStore, notifierStore } = useStores();
  const [ data, setData ] = useState({});
  const isMounted = useRef(true);

  useEffect(() => {
    setData(settingsStore.notificationSettings);

    return () => {
      isMounted.current = false;
    };
  }, [settingsStore]);

  const onSubmit = (values, actions) => {
    settingsStore.saveNotificationSettings((values))
      .then(() => notifierStore.showSuccess(t('Saved')))
      .catch(e => notifierStore.showError({ key: 'Couldn\'t save', props: { error: e.message || 'API error' }}))
      .finally(() => {
        actions.setSubmitting(false);
      });
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={
        {
          ...data,
        }
      }
      onSubmit={onSubmit}
    >{({
        handleChange,
        values,
        isSubmitting,
        resetForm,
      }) => (
        <Form className={'notification-form'}>
          {Object.keys(data).map((fieldName) => {
            return (
              <Row key={fieldName}>
                <FormGroup>
                  <Col sm={6} xs={4}>
                    <Checkbox
                      inline
                      className="mt-checkbox mt-checkbox-outline"
                      name={fieldName}
                      value={values[fieldName]}
                      checked={!!values[fieldName]}
                      onChange={handleChange}
                    >
                      <span/>
                    </Checkbox>

                    <ControlLabel>
                      {t(startCase(fieldName))}{' '}
                    </ControlLabel>
                  </Col>
                </FormGroup>
              </Row>
            );
          })}
          <Row>
            <Col sm={12} className="text-right">
              <Button onClick={() => resetForm()}>{t('Reset')}</Button>
              {' '}
              <LoadingButton
                bsStyle="primary"
                type="submit"
                label={t('Save')}
                loadingLabel={t('Saving')}
                isLoading={isSubmitting}
              />
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
});

export default withTranslation()(SettingsNotifications);
